// global configuration, do not modify these
$config = {};
$config.autoload = true;

// --------------------------------------

// Are users allowed to share folders outside of their team?
$config.enableSharingOutsideOwnTeam = true;

// Version-update notifications configuration
$config.enableVersionUpdateNotifications = true;

// PIN.net.au account configuration
$config.pin_publishable_key = '';

// Mailbox settings configuration
$config.mailbox = {};
$config.mailbox.userEditableSyncActive = true;
$config.mailbox.userEditableConnectionSettings = true;
$config.mailbox.userEditableNumberOfDays = true;
$config.mailbox.userEditableSyncFolders = true;
$config.mailbox.defaultAccessType = 'ews';
$config.mailbox.defaultHost = '';
$config.mailbox.defaultIMAPprefix = '';
$config.mailbox.defaultEWSpath = 'EWS/Exchange.asmx';
$config.mailbox.defaultPort = '';
$config.mailbox.defaultSecurity = '';

// API configuration

$config.api_protocol = 'https://';
$config.api_hostname = 'go.soupmail.com'
$config.api_path = '/api';
// --------------------------------------

// JS shortcuts, cross-browser compatible, do not modify these
$config.this_protocol = window.location.protocol.replace(':', '') + '://';
$config.this_hostname = window.location.hostname;
$config.this_path = window.location.pathname;

// tablet detection method, do not modify this
$config.isTabletDevice = function() {
  var dpr = 1;
  if (window.devicePixelRatio !== undefined) dpr = window.devicePixelRatio;
  var width=window.outerWidth/dpr;
  return (width >= 800);
};

// mobile detection regex, do not modify this
$config.mobile = (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));

// Permissions: can users choose "Contribute only" setting?
$config.enableContributeOnlyPermissions = true;



// WEBPACK FOOTER //
// ./src/js/configuration.js